import * as React from "react";
import { Provider } from "react-redux";
import { storeCreator, initialState } from "./Store";
import {
  fetchColumnMetadata,
  fetchResults,
  decodeBrowserPathToState,
  updateBrowserLocation,
} from "./../common/actions";
import App from "./App";
import {
  startBrowserHistoryListener,
  getLocation,
} from "./../common/services/BrowserLocation";
import { failPath } from "../config";

// set up the initial store
const store = storeCreator(initialState);
const state = store.getState();

// fetch field metadata (on time)
store.dispatch(fetchColumnMetadata(state.config.docsPath));

// establish listener to apply changes from back-button, etc.
startBrowserHistoryListener(store, failPath, decodeBrowserPathToState);

class FailuresApp extends React.Component {
  public render() {
    // look for any data in the URL to use to set initial state
    if (getLocation().search) {
      // use the supplied URL params if available
      // decodeBrowserPathToState also in turn calls the fetchResults
      store.dispatch(decodeBrowserPathToState(store, getLocation().search));
    } else {
      // otherwise, set URL params to reflect default state and get resutls
      store.dispatch(updateBrowserLocation(store.getState()));
      store.dispatch(fetchResults(state.query, state.config.apiPath));
    }
    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}

export default FailuresApp;
